import { getAuthorizationCode } from './auth';
import { DEVICES } from './device';
import Logger from './logger';

const getCode = ({ userStatus, code, device, callback }) => {
    switch (device) {
        case DEVICES.DESKTOP:
            if (userStatus && userStatus === 'loggedIn') {
                getAuthorizationCode(callback);
            } else {
                callback(null);
            }
            break;
        case DEVICES.MOBILE:
            if (code) {
                callback(code);
            } else {
                callback(null);
            }
            break;
    }
};

const isRelogin = (reloginRequestTimestamp) => {
    if (!reloginRequestTimestamp) {
        return false;
    }

    const timeSinceReloginRequest = (Date.now() - reloginRequestTimestamp) / 60000;
    Logger.log('timeSinceReloginRequest=', timeSinceReloginRequest);

    const isReloginActive = timeSinceReloginRequest <= 30 ? true : false;
    if (!isReloginActive) {
        window.WC._localStorage.clearAll('wc.relogin');
    }

    return isReloginActive;
};

const forceNewUser = (
    device,
    wasOpen,
    authorizationFailed,
    contactProcessType,
    userStatus,
    code
) => {
    Logger.log(
        `forceNewUser: device=${device}, wasOpen=${wasOpen}, authorizationFailed=${authorizationFailed}, contactProcessType=${contactProcessType}, userStatus=${userStatus}, code=${code}`
    );
    let forceNewUser = true;

    switch (device) {
        case DEVICES.DESKTOP:
            switch (wasOpen) {
                case true:
                    if (authorizationFailed || userStatus === 'loggedOut') {
                        forceNewUser = true;
                    } else {
                        forceNewUser = code ? true : false;
                    }
                    break;
                default:
                    forceNewUser = true;
                    break;
            }
            break;
        case DEVICES.MOBILE:
            if (contactProcessType?.toUpperCase() === 'REGISTRATION') {
                forceNewUser = userStatus && userStatus === 'loggedIn' && !code ? true : false;
            } else {
                forceNewUser = true;
            }
            break;
    }

    return forceNewUser;
};

export { getCode, isRelogin, forceNewUser };
